<template>
  <div id="sms">
    <div class="sms_back" @click="backSumbit">
      <i class="el-icon-arrow-left"></i>
      <span>返回上一层</span>
    </div>
    <div class="sms_title">请绑定手机号</div>
    <el-form class="sms_from" ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item prop="nickName">
        <el-input v-model.trim="form.nickName" placeholder="请输入您的昵称"></el-input>
      </el-form-item>
      <el-form-item prop="mobile">
        <el-input v-model.trim="form.mobile" placeholder="请输入您要绑定的手机号码"></el-input>
      </el-form-item>
      <el-form-item prop="verifyCode">
        <el-input class="verify_code" v-bind:class="{ isverify: !canClick}" v-model.trim="form.verifyCode" maxlength="6" placeholder="请输入您收到的短信验证码">
          <template slot="append">
            <div @click="getVerCode('form', 'mobile')">{{content}}</div>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="registerAction('form')" :loading="loadingBtn">绑定手机号</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { localToken } from "@/libs/util";
import requestImg from "@/assets/backhome.png";
import appApi from "@/api/api-app";
import { Message } from "element-ui";
export default {
  name: "sms",
  data() {
    var isMobileNumber = (rule, value, callback) => {
      let val = value;
      if (!val) {
        return new Error("请输入手机号码");
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        const isPhone = reg.test(value);
        val = Number(val); //转换为数字
        if (typeof val === "number" && !isNaN(val)) {
          //判断是否为数字
          val = val.toString(); //转换成字符串
          if (val.length < 0 || val.length > 12 || !isPhone) {
            //判断是否为11位手机号
            callback(new Error("手机号码格式如:138xxxx8754"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入手机号码"));
        }
      }
    };
    var isverifyNumber = (rule, value, callback) => {
      let val = value;
      if (!val) {
        return new Error("请输入短信验证码");
      } else {
        val = Number(val); //转换为数字
        if (typeof val === "number" && !isNaN(val)) {
          //判断是否为数字
          val = val.toString(); //转换成字符串
          if (val.length != 6) {
            callback(new Error("短信验证码格式如:123456"));
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入短信验证码"));
        }
      }
    };
    return {
      loadingBtn: false,
      tenantList: [],
      requestImg,
      selectTenant: null,
      form: {
        nickName:
          this.$route.query.nickName != undefined
            ? this.$route.query.nickName
            : "",
        mobile: "",
        verifyCode: "",
      },
      rules: {
        nickName: [
          { required: true, message: "请输入您的昵称", trigger: "blur" },
          { trigger: "blur" },
        ],
        mobile: [
          {
            required: true,
            message: "请输入您要绑定的手机号码",
            trigger: "blur",
          },
          { validator: isMobileNumber, trigger: "blur" },
        ],
        verifyCode: [
          {
            required: true,
            message: "请输入您收到的短信验证码",
            trigger: "blur",
          },
          { validator: isverifyNumber, trigger: "blur" },
        ],
      },
      content: "获取验证码",
      totalTime: 60,
      canClick: true, //添加canClick
    };
  },
  methods: {
    backSumbit() {
      this.$emit("back_sumbit", false);
    },
    getVerCode(formName, prop) {
      let that = this;
      // form为表单名字并ref="form"; prop 换成你想监听的prop字段
      that.$refs[formName].validateField(prop, (errMsg) => {
        if (errMsg) {
          console.log("校验失败");
        } else {
          let mobile = that.form.mobile;
          if (!that.canClick) return;
          appApi.getVerificationCode(mobile).then(
            (res) => {
              // 获取验证码
              that.canClick = false;
              that.totalTime = res.duration; //
              that.verifyCodeCountdown(); //开始倒计时
            },
            (err) => {
              console.log(err);
              that.totalTime = 180; //
              that.verifyCodeCountdown(); //开始倒计时
            }
          );
        }
      });
    },
    //倒计时
    verifyCodeCountdown() {
      let that = this;
      that.canClick = false; //禁止发送按钮
      that.content = that.totalTime + "s后重新发送";
      let clock = window.setInterval(() => {
        that.totalTime--;
        that.content = that.totalTime + "s后重新发送";
        if (that.totalTime < 1) {
          window.clearInterval(clock);
          that.content = "重新发送验证码";
          that.totalTime = 180;
          that.canClick = true;
        }
        //}, 1000);
        // todo 由于短信接口(阿里大鱼)限制1分钟内不允许重复发送 故倒计时是加上多了3秒左 即最低63秒才能发送一次短信
      }, 1050);
    },
    registerAction(formName) {
      let that = this;
      that.loadingBtn = true;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            nickName: that.form.nickName,
            smsCode: that.form.verifyCode,
            phoneNumber: that.form.mobile,
            tenantId: that.selectTenant,
          };
          appApi.getTokenByPhoneNumber(data).then(
            (res) => {
              that.loadingBtn = false;
              if (res.accessToken) {
                let data2 = {
                  openId: that.openId,
                  phoneNumber: that.form.mobile,
                  tenantId: that.selectTenant,
                };
                appApi.getTokenByOpenId(data2).then(
                  (res) => {
                    that.$router.push({
                      path: "/main",
                    });
                  },
                  (err) => {}
                );
              } else {
                Message({
                  message: JSON.stringify(res.message),
                  type: "error",
                });
              }
            },
            (err) => {
              that.loadingBtn = false;
            }
          );
        } else {
          that.loadingBtn = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    init() {
      let that = this;
      that.openId = localToken.getOpenId();
      let tenantIds = localToken.getTenantIds();
      let tenantNames = localToken.getTenantNames();
      let tenantIdArr = tenantIds.split(",");
      let tenantNameArr = tenantNames.split(",");
      that.tenantList = tenantIdArr.map((item, index) => {
        return {
          id: item,
          name: tenantNameArr[index] || "暂无名称",
        };
      });
      that.selectTenant =
        that.tenantList.length == 0 ? null : that.tenantList[0].id;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="less">
#sms {
  display: flex;
  flex-direction: column;
  > .sms_back {
    width: 120px;
    cursor: pointer;
    position: absolute;
    color: #fff;
  }

  > .sms_back,
  > .tenant_title,
  > .sms_title {
    padding: 20px;
  }
  .sms_title {
    letter-spacing: 1px;
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    background: radial-gradient(
      circle farthest-corner at 55% 55%,
      #509eef,
      #2577ec
    );
    margin-bottom: 30px;
  }
  > .tenant {
    cursor: pointer;
    padding: 8px;
    width: 200px;
    margin: auto;
    // margin-bottom: 10px;
    background-color: #ebebeb;
    border: 1px solid #fff;
    display: flex;
    align-items: center;
    border-radius: 4px;
    > span {
      flex: 1;
      font-size: 16px;
    }
    > img {
      transform: rotate(180deg);
    }
  }
  > .tenant.select {
    color: #fff;
    background-color: #409eff;
  }
  .sms_from {
    width: 320px;
    margin: auto;
    .el-form-item > .el-form-item__content {
      margin-left: 0px !important;
      .verify_code.el-input {
        > .el-input__inner {
          border-radius: 4px !important;
        }
        > .el-input-group__append {
          top: 0px !important;
          background-color: #fff !important;
          color: #2577ec !important;
          border: none !important;
          position: absolute !important;
          margin: 10px 0px !important;
          width: 100px !important;
          right: 8px !important;
          text-align: right !important;
          padding: 0px !important;
        }
      }
      .el-button--primary {
        width: 320px !important;
        background-color: #2577ec !important;
      }
    }
    .verify_code {
      cursor: pointer;
    }
    .isverify.verify_code {
      cursor: auto;
    }
  }
}
// #index {
//   display: flex;
//   flex-direction: column;
//   > .tenant > .el-radio-button {
//     cursor: pointer;
//     // margin: 4px;
//     width: 200px;
//     margin: auto;
//     margin-bottom: 10px;
//     // background-color: #ebebeb;

//     display: flex;
//     align-items: center;
//     .el-radio-button__inner {
//       border: 1px solid #dcdfe6;
//       border-radius: 4px;
//     }
//     > span {
//       flex: 1;
//       font-size: 18px;
//     }
//     > img {
//       transform: rotate(180deg);
//     }
//   }
// }
</style>


// WEBPACK FOOTER //
// src/view/index/sms.vue